import React from 'react'

import { Bold } from '../../../../components/pdf/Text'
import { Table, TableRow } from '../../../../components/pdf/Table'
import { TableColLabelValue, TableColText, TableHeadText } from '../../../../components/pdf/TableHelpers'

const PointsTableWithImage = ({ sections, classifications }) => {
  const allRows = sections.reduce(
    (rows, section) => [
      ...rows,
      ...(section.rows || []),
      ...(section.categories || []).reduce((rows, category) => [...rows, category?.rows], [])
    ],
    []
  )

  const truePoints = allRows.reduce((sum, row) => sum + (row.value === true ? row.points : 0), 0)
  const conclusion = classifications.find(item => truePoints >= item.min && (!item.max || truePoints <= item.max))

  return (
    <Table width="100%">
      {sections.map((section, sectionIndex) => (
        <>
          <TableRow key={sectionIndex}>
            <TableHeadText colSpan={2}>{section.label}</TableHeadText>
            <TableHeadText align="center">Sim</TableHeadText>
            <TableHeadText align="center">Não</TableHeadText>
          </TableRow>

          {section.rows?.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              <TableColText colSpan={2}>{row.label}</TableColText>
              <TableColText align="center">{row.value === true ? 'X' : ''}</TableColText>
              <TableColText align="center">{row.value === false ? 'X' : ''}</TableColText>
            </TableRow>
          ))}

          {section.categories?.map((category, categoryIndex) =>
            category.rows?.map((row, rowIndex) => {
              if (row.separator) {
                return (
                  <TableRow key={rowIndex}>
                    <TableHeadText align="center" bold colSpan={3}>
                      {row.label}
                    </TableHeadText>
                  </TableRow>
                )
              }
              return (
                <TableRow key={rowIndex}>
                  {rowIndex === 0 && (
                    <TableColText align="center" rowSpan={category.rows.length}>
                      {category.label}
                    </TableColText>
                  )}
                  <TableColText>
                    {row.label}
                    {!!row.points ? ` (${row.points} ${row.points > 1 ? 'pts.' : 'pt.'})` : ''}
                  </TableColText>
                  <TableColText align="center">{row.value === true ? 'X' : ''}</TableColText>
                  <TableColText align="center">{row.value === false ? 'X' : ''}</TableColText>
                </TableRow>
              )
            })
          )}

          {section.footer && (
            <TableRow>
              <TableColText colSpan={4} bold size="small">
                {section.footer}
              </TableColText>
            </TableRow>
          )}
        </>
      ))}

      <TableRow>
        <TableHeadText colSpan={2} align="right">
          Somatória:
        </TableHeadText>
        <TableHeadText colSpan={2} align="center">
          {truePoints}
        </TableHeadText>
      </TableRow>

      <TableRow>
        <TableColText colSpan={4}>
          <Bold>Critério de Interpretação</Bold>
          <br />
          {classifications.map(item => (
            <>
              {item.max >= 0 ? `Entre ${item.min} e ${item.max}` : `Acima de ${item.min}`} pontos - {item.label}
              <br />
            </>
          ))}
        </TableColText>
      </TableRow>

      <TableColLabelValue label="Interpretação" value={conclusion?.label} colSpan={4} />
    </Table>
  )
}

export default PointsTableWithImage
